// An uploaded image stored compressed (`<uuid>.png.gz`) as something an
// <img> can show. Two formats exist: older uploads are ZIP archives, newer
// ones plain gzip of the image; the server may also inflate on the way.
//
// A missing or unreadable image resolves to null - never to the bare
// relative name, which the browser then fetched from the current page's
// path and 404'd on every page (the header avatar, 2026-09-18). Callers
// show their own placeholder for null.
import { url } from "api";
import JSZip from "jszip";
import pako from "pako";

const TYPES = { jpg: "image/jpeg", jpeg: "image/jpeg", gif: "image/gif", webp: "image/webp", png: "image/png" };

export const extractImageFromZip = async (uri) => {
  if (!uri) return null;
  if (String(uri).split(".").pop() !== "gz") return uri;
  try {
    const path = String(uri).replace(/^\/?(uploads\/)?/, "");
    const res = await fetch(/^https?:/i.test(uri) ? uri : `${url}/uploads/${path}`);
    if (!res.ok) return null;
    const bytes = new Uint8Array(await res.arrayBuffer());
    if (bytes[0] === 0x50 && bytes[1] === 0x4b) {
      // ZIP archive: the first image inside.
      const zip = await JSZip.loadAsync(bytes);
      const name = Object.keys(zip.files).find((f) => /\.(jpe?g|png|gif|webp)$/i.test(f));
      if (!name) return null;
      return window.URL.createObjectURL(await zip.file(name).async("blob"));
    }
    const raw = bytes[0] === 0x1f && bytes[1] === 0x8b ? pako.ungzip(bytes) : bytes;
    const ext = (String(uri).match(/\.([a-z]+)\.gz$/i) || [])[1] || "png";
    return window.URL.createObjectURL(new Blob([raw], { type: TYPES[ext.toLowerCase()] || "image/png" }));
  } catch (error) {
    return null;
  }
};
